import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CardBody = ({
  children,
  type,
}) => (
  <div
    className={classnames('CardBody', type)}
  >
    {children}
  </div>
);

CardBody.propTypes = {
  type: PropTypes.string,
  children: PropTypes.any.isRequired,
};

CardBody.defaultProps = {
  type: null,
};

export default CardBody;
